import React from "react";
import css from "../../../Assets/Styles/Footer.module.css";
import logo from "../../../Assets/Images/logo/Global-IT-Master-Footer-Logo-removebg-preview.png";

const SubFooter = () => {
  return (
    <section className={css.sub_footer}>
      <div className="2xl:max-w-[1320px] max-xl:max-w-[1150px] mx-auto flex justify-between items-center py-6 flex-col max-md:flex-row gap-10 ">
        <img className="w-[230px] h-[50px]" src={logo} alt="IT Ghar" />
        <div className="flex gap-5 justify-center  items-center">
          <h6 className="text-[#8A94A7]">Follow Us:</h6>
          <div className="flex gap-4 justify-center items-center">
            <a
              className=" w-12 h-12 bg-[#313E55] text-[#fff] text-sm  rounded-full flex justify-center  items-center
              "
              href="https://www.facebook.com/itghar.bd"
              target="_black"
            >
              <i className="fa-brands fa-facebook-f"></i>
            </a>
            {/* <a
              className="w-12 h-12 bg-[#ffffff] text-[#313E55] text-sm  rounded-full flex justify-center  items-center"
              href="https://twitter.com/webnexit"
              target="_black"
            >
              <i className="fa-brands fa-twitter"></i>
            </a>
            <a
              className="w-12 h-12 bg-[#313E55] text-[#fff] text-sm  rounded-full flex justify-center  items-center"
              href="https://www.linkedin.com/company/webnex-it"
              target="_black"
            >
              <i className="fa-brands fa-linkedin-in"></i>
            </a> */}
          </div>
        </div>
        <p className="text-[#8A94A7] text-base">
          Copyright © 2024 itghorbd. All Rights Reserved
        </p>
      </div>
    </section>
  );
};

export default SubFooter;
